import { IgUser } from '@core/models/ApiFields/ig-entities';
import { ColCateg, Sorting } from '@features/social-analysis/models/ITable';
import { COMPONENTS_ENUM } from './page.config';
import { getDefaultColsObj } from '@features/social-analysis/utils/table-utils';

export const igUsersFields = [
    IgUser.getPrefixed('biography'),
    IgUser.getPrefixed('captionsNegativity'),
    IgUser.getPrefixed('captionsPositivity'),
    IgUser.getPrefixed('commentsCount'),
    IgUser.getPrefixed('commentsNegativity'),
    IgUser.getPrefixed('commentsPositivity'),
    IgUser.getPrefixed('followers'),
    IgUser.getPrefixed('image'),
    IgUser.getPrefixed('influencer'),
    IgUser.getPrefixed('interactions'),
    IgUser.getPrefixed('interactionsNegativity'),
    IgUser.getPrefixed('interactionsPositivity'),
    IgUser.getPrefixed('lastInteractionAt'),
    IgUser.getPrefixed('mediaCount'),
    IgUser.getPrefixed('tagsCount'),
    IgUser.getPrefixed('negativeCaptions'),
    IgUser.getPrefixed('negativeComments'),
    IgUser.getPrefixed('negativeInteractions'),
    IgUser.getPrefixed('positiveCaptions'),
    IgUser.getPrefixed('positiveComments'),
    IgUser.getPrefixed('positiveInteractions'),
    IgUser.getPrefixed('professional'),
    IgUser.getPrefixed('profileLink'),
    IgUser.getPrefixed('username'),
    IgUser.getPrefixed('website'),
];

const columns: ColCateg[] = [
    {
        display: 'social',
        values: [
            {
                display: 'Username',
                value: IgUser.getPrefixed('username'),
                fixed: true,
                defaultCol: true,
                fixWidth: 220,
            },
            {
                display: 'Influencer',
                value: IgUser.getPrefixed('influencer'),
                defaultCol: true,
            },
            {
                display: 'Interactions Sentiment',
                value: IgUser.getPrefixed('interactionsPositivity'),
                defaultCol: true,
            },
            {
                display: 'Interactions',
                value: IgUser.getPrefixed('interactions'),
                defaultCol: true,
            },
            {
                display: 'Num. of Tags',
                value: IgUser.getPrefixed('tagsCount'),
                defaultCol: true,
            },
            {
                display: 'Num. of Posts',
                value: IgUser.getPrefixed('mediaCount'),
            },

            {
                display: 'Captions Sentiment',
                value: IgUser.getPrefixed('captionsPositivity'),
            },
            {
                display: 'Comments Count',
                value: IgUser.getPrefixed('commentsCount'),
                defaultCol: true,
            },
            {
                display: 'Comments Sentiment',
                value: IgUser.getPrefixed('commentsPositivity'),
            },
            {
                display: 'Followers',
                value: IgUser.getPrefixed('followers'),
            },
            {
                display: 'Last Interaction',
                value: IgUser.getPrefixed('lastInteractionAt'),
            },

            {
                display: 'Negative Captions',
                value: IgUser.getPrefixed('negativeCaptions'),
            },
            {
                display: 'Negative Comments',
                value: IgUser.getPrefixed('negativeComments'),
            },
            {
                display: 'Positive Captions',
                value: IgUser.getPrefixed('positiveCaptions'),
            },
            {
                display: 'Positive Comments',
                value: IgUser.getPrefixed('positiveComments'),
            },
            {
                display: 'Positive Interactions',
                value: IgUser.getPrefixed('positiveInteractions'),
            },
            {
                display: 'Negative Interactions',
                value: IgUser.getPrefixed('negativeInteractions'),
            },
            {
                display: 'Website',
                value: IgUser.getPrefixed('website'),
            },
        ],
    },
];

const defaultSort: Sorting[] = [{ prop: IgUser.getPrefixed('lastInteractionAt'), dir: 'desc' }];

export const socUsersTableInit = {
    component: COMPONENTS_ENUM.USERS,
    columns: columns,
    selectedCols: getDefaultColsObj(columns),
    hiddenSort: defaultSort,
};
